import { List, ListItem, ListItemButton } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { usePreceedingAndFollowingTurns } from '~/hooks/api/usePreceedingAndFollowingTurns';
import Spacings from '~/modules/ui-kit/spacings';
import { toNational } from '~/utils/phone-number-helpers';
import InformationalSection from '../InformationalSection';
import messages from './messages';

type PrecedingAndFollowingTeamsProps = {
  turnId: number;
  onPublisherClick: (args: { phone: string }) => void;
  settings: {
    masterData: {
      defaultRegionCallingCode: string;
    };
  };
};

const PrecedingAndFollowingTeams = (props: PrecedingAndFollowingTeamsProps) => {
  const { data: turns, isFetching } = usePreceedingAndFollowingTurns({
    id: props.turnId,
  });
  return (
    <InformationalSection title={<FormattedMessage {...messages.title} />}>
      {isFetching && <CircularProgress />}
      <Spacings.Stack>
        {!isFetching &&
          turns &&
          turns.map((turn) => (
            <Spacings.Inline key={turn.id} scale="xs">
              <Spacings.Inset>
                <div>
                  <Typography variant="subtitle1">
                    {moment(turn.startDate).format('llll')}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {turn.routeName}
                  </Typography>
                </div>
              </Spacings.Inset>
              <List style={{ flexGrow: '1' }}>
                {turn.team?.map((publisher) => (
                  <ListItem disablePadding key={publisher.id}>
                    <ListItemButton
                      onClick={() =>
                        props.onPublisherClick({ phone: publisher.phone! })
                      }
                      sx={{
                        borderStyle: 'none',
                        backgroundColor: 'transparent',
                      }}
                    >
                      <Spacings.Stack scale="none" alignItems="flexStart">
                        <Typography variant="subtitle1">
                          {publisher.firstName} {publisher.lastName}
                        </Typography>
                        <Typography color="textSecondary">
                          {toNational(
                            publisher.phone!,
                            props.settings?.masterData?.defaultRegionCallingCode
                          )}
                        </Typography>
                      </Spacings.Stack>
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Spacings.Inline>
          ))}
      </Spacings.Stack>
    </InformationalSection>
  );
};

export default PrecedingAndFollowingTeams;
